var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightHanging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.265 445.875L437.261 153.75C433.51 138.5 420.76 128 406.384 128H346.13C349.755 118 352.006 107.25 352.006 96C352.006 43 309.003 0 256 0S159.994 43 159.994 96C159.994 107.25 162.245 118 165.87 128H105.616C91.24 128 78.49 138.5 74.739 153.75L1.735 445.875C-6.64 479.125 16.361 512 47.988 512H464.012C495.639 512 518.64 479.125 510.265 445.875ZM256 128C238.374 128 223.998 113.625 223.998 96S238.374 64 256 64C273.626 64 288.002 78.375 288.002 96S273.626 128 256 128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightHanging);
export default __webpack_public_path__ + "static/media/weight-hanging.e493db7980860d852b2d1416b9323cf8.svg";
export { ForwardRef as ReactComponent };